module.exports = __webpack_public_path__ + "static/media/md-arrow-round-back.99fa174c.svg";